import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import AppDialog from '@/components/AppDialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorDialog',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    default: 'Error',
  },
  message: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(AppDialog, {
    "model-value": __props.modelValue,
    title: __props.title,
    icon: "mdi-alert",
    "icon-color": "#dc2626",
    "max-width": "700",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => emit('update:modelValue', value))
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "error",
        variant: "outlined",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createTextVNode("Close")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", {
        class: "error-message",
        innerHTML: __props.message
      }, null, 8, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})